\<template>
  <div class="event-modal-catalog-package-logo">
    <div class="event-modal-catalog-package-logo__box">
      <h2 class="event-modal-catalog-package-logo__title">
        <slot name="title"></slot>
      </h2>

      <p class="event-modal-catalog-package-logo__text">
        <slot name="description"></slot>
      </p>
      <div class="event-modal-catalog-package-logo__input">
        <slot name="input"></slot>
      </div>

      <div class="event-modal-catalog-package-logo__bottom">
        <a
          v-if="files[fileType]"
          href="#"
          class="event-modal-catalog-package-logo__bottom-download-link"
          download
          @click="downloadFile($event)"
        >
          <icon name="blank-doc-transparent" />
          <span>
            {{ $t("event.catalog.modal.preview.documents.downloadFile") }}

            <small v-if="logoFileParams">
              {{ logoFileParams }}
            </small>
          </span>
        </a>

        <div
          v-if="hasAccessToWrite"
          class="event-modal-catalog-package-logo__bottom-upload"
        >
          <LinkIcon
            :disabled="!isRequiredUpload"
            :icon="files[fileType] ? 'link-icon-edit' : 'load'"
          >
            {{
              files[fileType]
                ? $t("event.catalog.modal.logo.changeBtn")
                : $t("event.catalog.modal.logo.loadBtn")
            }}
          </LinkIcon>

          <input
            v-if="isRequiredUpload"
            type="file"
            @change="fileChanged"
            :accept="fileAccept"
          />
        </div>

        <div
          v-if="hasAccessToWrite && files[fileType]"
          class="event-modal-catalog-package-logo__bottom-upload"
        >
          <LinkIcon bold icon="delete-primary" @click="removeFile">
            {{ $t("event.catalog.modal.logo.destroyBtn") }}
          </LinkIcon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { LinkIcon } from "@v2/shared/ui/components";

export default {
  name: "EventModalCatalogPackageLogo",

  components: {
    LinkIcon
  },
  props: {
    isRequiredUpload: {
      type: Boolean,
      default: false
    },
    fileType: {
      type: String,
      default: "logoFile"
    },
    fileAccept: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters("event", ["hasAccessToWrite", "eventId"]),
    ...mapState("event", ["event"]),

    ...mapState("eventCatalog", {
      orderLogo: "packagePlacementLogoLink",
      files: "files"
    }),

    logoFileParams() {
      if (this.files[this.fileType]) {
        return `${this.files[this.fileType].extension}, ${(
          +this.files[this.fileType].size / 1024
        ).toFixed(2)} Кб`;
      }

      return "";
    }
  },

  methods: {
    fileChanged(e) {
      this.$emit("fileChanged", e);
    },

    downloadFile(e) {
      this.$emit("downloadFile", e);
    },

    removeFile() {
      this.$emit("removeFile");
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";

.event-modal-catalog-package-logo {
  display: flex;
  flex-wrap: wrap;
  &__box {
    width: 100%;
  }
  &__preview {
    display: flex;

    width: 200px;
    height: 112px;

    flex-shrink: 0;

    margin-right: 40px;

    background: #f6f6f6;

    &-image {
      max-width: 100%;
      max-height: 100%;
      margin: auto;
    }
  }

  &__title {
    @include h2();
    margin-bottom: 15px;
  }
  &__input {
    margin-bottom: 22px;
  }
  &__text {
    @include description();
    margin-top: 6px;
    margin-bottom: 22px;
  }

  &__bottom {
    display: flex;
    align-items: flex-start;

    &-download-link {
      display: flex;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.5;
      color: #009ee3;

      text-decoration: none;
      user-select: none;
      cursor: pointer;

      .svg-icon {
        width: 16px;
        height: 16px;
        margin-right: 9px;
      }
      small {
        display: block;
        margin-top: 2px;
        margin-left: 1px;
        font-weight: 400;
        font-size: 12px;
        line-height: 1.5;
        color: #a3a8b3;
      }
    }

    &-upload {
      display: inline-block;
      position: relative;
      &:not(:first-child) {
        margin-left: 20px;
      }
      input {
        position: absolute;
        top: 0;
        left: 0;

        width: 100%;
        height: 100%;

        font-size: 0;

        cursor: pointer;

        opacity: 0;
      }
    }
  }

  &__error {
    width: 100%;
    flex-shrink: 0;
    margin-top: 1em;
  }
}
</style>
